import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessModifierGroupManagerHandler {
 	url: any;
 	token: any;
  	businessId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
	}

	getModifierGroups(params){	
	  	this.url = this.globals.dataUrl + 'businessModifierGroup' + 
	                                      '/page/' + params.page +
	                                      '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getModifiers(params){	
	  	this.url = this.globals.dataUrl + 'businessModifierGroup' + 
	  									  '/group/' + params.modifierGroupId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getModifierGroup(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessModifierGroup/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

	create(params, cb){
	    this.url = this.globals.dataUrl + 'businessModifierGroup';

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    });  
		})           
	}

	delete(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessModifierGroup/' + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.delete(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res);
		    });   
    	})
  	}

	update(id, params, cb){
	    this.url = this.globals.dataUrl + 'businessModifierGroup/' + id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    }); 
		});             
	}

	getAvailableModifierGroups(id, cb){	
	  	this.url = this.globals.dataUrl + 'businessProductSubCategory/modifiers/' + id + '/all';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

	toggleModifierGroup(params, cb){
		this.url = this.globals.dataUrl + 'businessModifierGroup/group/' + params.id +
											'/subcategory/' + params.subCategoryId + 
											'/selected/' + params.isSelected;

		this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .post(
		      this.url, 
		      null, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof cb == "function") cb(response);
		    });  
		})               
	}	

}



// WEBPACK FOOTER //
// ./src/providers/business-modifier-group-handler.ts